import {
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
} from '../PolymorphicSerializer.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  KSerializerzf77vz1967fq as KSerializer,
} from '../KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function decodeSequentially($this, compositeDecoder) {
  var klassName = compositeDecoder.decodeStringElement_3oenpg_k$($this.get_descriptor_wjt6a0_k$(), 0);
  var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
  return compositeDecoder.decodeSerializableElement$default_j0zaoi_k$($this.get_descriptor_wjt6a0_k$(), 1, serializer);
}
var AbstractPolymorphicSerializerClass;
function AbstractPolymorphicSerializer() {
  if (AbstractPolymorphicSerializerClass === VOID) {
    class $ {
      static new_kotlinx_serialization_internal_AbstractPolymorphicSerializer_mpc34r_k$() {
        return createThis(this);
      }
      serialize_kj9hv3_k$(encoder, value) {
        var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeStringElement_1n5wu2_k$(this.get_descriptor_wjt6a0_k$(), 0, actualSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        var tmp = this.get_descriptor_wjt6a0_k$();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$2 = isInterface(actualSerializer, SerializationStrategy()) ? actualSerializer : THROW_CCE();
        composite.encodeSerializableElement_isqxcl_k$(tmp, 1, tmp$ret$2, value);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kj9hv3_k$(encoder, !(value == null) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var tmp$ret$1;
        $l$block: {
          var klassName = null;
          var value = null;
          if (composite.decodeSequentially_xlblqy_k$()) {
            tmp$ret$1 = decodeSequentially(this, composite);
            break $l$block;
          }
          mainLoop: while (true) {
            var index = composite.decodeElementIndex_bstkhp_k$(this.get_descriptor_wjt6a0_k$());
            switch (index) {
              case -1:
                break mainLoop;
              case 0:
                klassName = composite.decodeStringElement_3oenpg_k$(this.get_descriptor_wjt6a0_k$(), index);
                break;
              case 1:
                var tmp0 = klassName;
                var tmp$ret$2;
                $l$block_0: {
                  // Inline function 'kotlin.requireNotNull' call
                  if (tmp0 == null) {
                    var message = 'Cannot read polymorphic value before its type token';
                    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
                  } else {
                    tmp$ret$2 = tmp0;
                    break $l$block_0;
                  }
                }

                klassName = tmp$ret$2;
                var serializer = findPolymorphicSerializer(this, composite, klassName);
                value = composite.decodeSerializableElement$default_j0zaoi_k$(this.get_descriptor_wjt6a0_k$(), index, serializer);
                break;
              default:
                var tmp0_elvis_lhs = klassName;
                throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
            }
          }
          var tmp0_0 = value;
          var tmp$ret$4;
          $l$block_1: {
            // Inline function 'kotlin.requireNotNull' call
            if (tmp0_0 == null) {
              var message_0 = 'Polymorphic value has not been read for class ' + klassName;
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
            } else {
              tmp$ret$4 = tmp0_0;
              break $l$block_1;
            }
          }
          var tmp = tmp$ret$4;
          tmp$ret$1 = !(tmp == null) ? tmp : THROW_CCE();
        }
        var result = tmp$ret$1;
        composite.endStructure_1xqz0n_k$(descriptor);
        return result;
      }
      findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName) {
        return decoder.get_serializersModule_piitvg_k$().getPolymorphic_mdqbv5_k$(this.get_baseClass_lygw3m_k$(), klassName);
      }
      findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value) {
        return encoder.get_serializersModule_piitvg_k$().getPolymorphic_igvsfc_k$(this.get_baseClass_lygw3m_k$(), value);
      }
    }
    initMetadataForClass($, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer()]);
    AbstractPolymorphicSerializerClass = $;
  }
  return AbstractPolymorphicSerializerClass;
}
function throwSubtypeNotRegistered(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.get_simpleName_r6f8py_k$() + "'";
  throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.get_simpleName_r6f8py_k$() + "' has to be sealed and '@Serializable'."));
}
function throwSubtypeNotRegistered_0(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.get_simpleName_r6f8py_k$();
  throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
//region block: exports
export {
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  throwSubtypeNotRegistered as throwSubtypeNotRegistered2cr459177l268,
  throwSubtypeNotRegistered_0 as throwSubtypeNotRegistered343gt7v9eqwun,
};
//endregion

//# sourceMappingURL=AbstractPolymorphicSerializer.mjs.map
